import PageNames from 'pages/page-names'
import pages from '../../../pages'

export const setDMRedsign = (hppSettings: HPPSettings, page: string | undefined) => {
  const experiments = hppSettings.experiments
  const isDMRedesignExperiment =
    experiments &&
    experiments.some(experiment => experiment.featureKey === 'frontend-dm-redesign-experiment')

  const isRedesignedDistributionPaymentPageVisible =
    isDMRedesignExperiment && hppSettings.page === PageNames.DISTRIBUTION_PAYMENT

  const loadPageComponent = isRedesignedDistributionPaymentPageVisible
    ? pages[PageNames.DISTRIBUTION_PAYMENT_REDESIGN]
    : pages[hppSettings.page]

  page = isRedesignedDistributionPaymentPageVisible
    ? PageNames.DISTRIBUTION_PAYMENT_REDESIGN
    : hppSettings.page

  return { loadPageComponent, page }
}
